module.exports = __webpack_public_path__ + "img/thumbnail_AfricanLeopard_f_normal.82ecaba4.png";